<template>
    <div class="mainC">
        <Finished :key="dateNtime"/>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Finished from './Finished';

export default {
  name: 'FinishedPar',
  data(){
      return{
        
      }
  },
  async mounted(){
      
    

  },


    methods:{
        ...mapActions(['setdateNtime', 'setLeagueId']),
    
    },  
  components: {
      Finished,
  },
  props: {
    
  },
  computed: { 
      ...mapGetters(['dateNtime','leagueIDe']),
    },

  watch: {
      dateNtime: function(){
        },
  },
}

</script>

<style scoped>

</style>
